export const getFullName = (user = {}) =>
  [
  	user.first_name || '',
  	user.last_name || ''
  ]
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();

export default getFullName;
